import React from 'react';

export const CreativeTemplate = ({ data }) => {
  return (
    <div className="flex h-full min-h-[297mm] font-sans">
      {/* Sidebar */}
      <div className="w-1/3 bg-slate-900 text-white p-8 border-r border-slate-800">
        <div className="sticky top-8">
            <div className="mb-8">
            <div className="w-32 h-32 bg-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center text-4xl font-bold">
                {data.personalInfo.firstName[0]}{data.personalInfo.lastName[0]}
            </div>
            <h1 className="text-2xl font-bold text-center mb-2">{data.personalInfo.firstName} {data.personalInfo.lastName}</h1>
            <p className="text-blue-400 text-center text-sm mb-6 uppercase tracking-widest">Professional</p>
            </div>

            <div className="space-y-6 text-sm">
            <div>
                <h3 className="text-xs font-bold uppercase text-gray-400 mb-3 tracking-wider">Contact</h3>
                <div className="space-y-2 text-gray-300">
                <p className="break-all">{data.personalInfo.email}</p>
                <p>{data.personalInfo.phone}</p>
                <p className="break-all">{data.personalInfo.linkedin}</p>
                <p className="break-all">{data.personalInfo.website}</p>
                </div>
            </div>
            </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-2/3 bg-white p-8">
        {data.personalInfo.summary && (
          <div className="mb-10">
             <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
               <span className="w-2 h-8 bg-blue-500 mr-3 rounded-sm"></span> Profile
             </h2>
             <p className="text-gray-600 leading-relaxed">{data.personalInfo.summary}</p>
          </div>
        )}

        {/* Dynamic Sections */}
        {data.sectionsOrder.map((sectionId) => {
             // Experience
             if (sectionId === 'experience' && data.experience.length > 0) {
                 return (
                    <div key={sectionId} className="mb-10">
                    <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                        <span className="w-2 h-8 bg-blue-500 mr-3 rounded-sm"></span> Experience
                    </h2>
                    <div className="space-y-8 border-l-2 border-slate-100 ml-3 pl-8 relative">
                        {data.experience.map((exp) => (
                        <div key={exp.id} className="relative">
                            <div className="absolute -left-[39px] top-1 w-5 h-5 rounded-full border-4 border-white bg-blue-500"></div>
                            <h3 className="text-lg font-bold text-slate-800">{exp.role}</h3>
                            <div className="flex justify-between items-center mb-2">
                            <span className="text-blue-600 font-medium">{exp.company}</span>
                            <span className="text-gray-400 text-sm bg-slate-50 px-2 py-1 rounded">{exp.startDate} - {exp.endDate}</span>
                            </div>
                            <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-wrap">{exp.description}</p>
                        </div>
                        ))}
                    </div>
                    </div>
                 );
             }

             // Education
             if (sectionId === 'education' && data.education.length > 0) {
                 return (
                    <div key={sectionId} className="mb-10">
                        <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                             <span className="w-2 h-8 bg-blue-500 mr-3 rounded-sm"></span> Education
                        </h2>
                        <div className="space-y-6">
                            {data.education.map((edu) => (
                            <div key={edu.id} className="bg-slate-50 p-4 rounded-lg border border-slate-100">
                                <div className="flex justify-between items-baseline mb-1">
                                    <h3 className="font-bold text-slate-800">{edu.school}</h3>
                                    <span className="text-gray-500 text-sm">{edu.year}</span>
                                </div>
                                <p className="text-blue-600 text-sm font-medium">{edu.degree}</p>
                            </div>
                            ))}
                        </div>
                    </div>
                 );
             }

             // Skills
             if (sectionId === 'skills' && data.skills.length > 0) {
                 return (
                    <div key={sectionId} className="mb-10">
                        <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                             <span className="w-2 h-8 bg-blue-500 mr-3 rounded-sm"></span> Skills
                        </h2>
                        <div className="flex flex-wrap gap-2">
                             {data.skills.map((skill, index) => (
                                <span key={index} className="bg-slate-100 text-slate-700 px-3 py-1.5 rounded text-sm font-medium border border-slate-200">
                                {skill}
                                </span>
                             ))}
                        </div>
                    </div>
                 );
             }

             // Custom Sections
             const customSection = data.customSections.find(s => s.id === sectionId);
             if (customSection && customSection.items.length > 0) {
                 return (
                    <div key={sectionId} className="mb-10">
                        <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                             <span className="w-2 h-8 bg-blue-500 mr-3 rounded-sm"></span> {customSection.title}
                        </h2>
                        <div className="space-y-6">
                            {customSection.items.map((item) => (
                            <div key={item.id} className="relative">
                                <h3 className="text-lg font-bold text-slate-800">{item.name}</h3>
                                {item.link && <a href={`https://${item.link}`} target="_blank" rel="noreferrer" className="text-blue-500 text-sm hover:underline block mb-1">{item.link}</a>}
                                <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-wrap">{item.description}</p>
                            </div>
                            ))}
                        </div>
                    </div>
                 );
             }
             return null;
        })}

      </div>
    </div>
  );
};
